import "./history.scss"

export default function History() {
    return (
        <div className="history">
            <div className="historyTitle">
                <h1> HOW IT STARTED ...</h1>
            </div>
            <div className="historyDesc">
                <p>
                About 1,000 years before we even thought about Christ, a couple of villages laid clustered around what is now known as the JOS plateau.The people living in these villages were intelligent and had cultures and traditions in place. In fact, they are the only known civilization already living far south from Egypt at that period. These  guys were like the modern day Kim Kardashians, spending half of their time staring at water reflections and moulding images of themselves. They had sexy lips without plastic surgery, so why not?
                </p>
                <p>
                Something happened though, to these ancient-day Kim Kardashians, and for some reasons they were wiped off the face of the earth. So now their spirits are back and they want you. Yes, you! It’s your job to find out what happened to their culture and in return, they will reward you with modern day selfies of what they used to look like.
                </p>
                <p>
                Are you ready to take on the mantle of avenging the NOK?
                </p>
                <p>
                Check out some other perks attached to being a NOKKER
                </p>

            </div>
        </div>
    )
}
